<template>
    <div class="product-card">
        <div class="product-card-top">
            <a :href="productUrl" class="product-image">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product image">
            </a>

            <ul class="list-inline product-badge">
                <li v-if="product.is_out_of_stock" class="mb-2">
                    {{ $trans('ecommerce::product_card.out_of_stock') }}
                </li>

                 <li v-if="product.has_percentage_special_price" class="special-price-percent mb-2">
                    -{{ product.special_price_percent }}%
                </li>

                <li class="product-new" v-else-if="product.is_new">
                    {{ $trans('ecommerce::product_card.new') }}
                </li>

            </ul>
        </div>

        <div class="product-card-info px-2">
            <div class="product-info">
                <div class="product-price"  v-html="product.formatted_price"></div>
<!--                <div class="product-card-actions">-->
                    <button
                        class="btn btn-wishlist"
                        :class="{ 'added': inWishlist }"
                        :title="$trans('ecommerce::product_card.wishlist')"
                        @click="syncWishlist"
                    >
                        <i class="la-heart" :class="inWishlist ? 'las' : 'lar'"></i>
                    </button>
<!--                </div>-->
            </div>
            <a :href="productUrl" class="product-name"><h6><span v-if="product.brand.name" class="item-brand mr-1">{{ product.brand.name }}</span>{{ product.name }}</h6></a>
            <div class="product-info py-1">
                <ProductRating :ratingPercent="product.rating_percent" :reviewCount="product.reviews.length"/>
                <ProductSold :sold="product.sold" />
            </div>
        </div>
<!--        <ProductProgress :sold="product.sold" :qty="product.qty" />-->
    </div>
</template>

<script>
import ProductRating from "./ProductRating.vue";
import ProductProgress from "./ProductProgress.vue";
import ProductSold from "./ProductSold.vue";
import ProductCardMixin from "../mixins/ProductCardMixin";

export default {
    components: { ProductRating, ProductProgress, ProductSold },

    mixins: [ProductCardMixin],

    props: ["product"]
};
</script>
